import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Divider } from 'antd';
import Activities from './shared-components/Activities';
import Header from './shared-components/Header';
import Balances from './shared-components/Balances';
import {
  pageAtom,
  rowsAtom,
  businessAtom,
  stripePayoutsAtom,
  loadingStripePayoutsAtom,
  refreshStripePayoutsAtom
} from '../../../../atoms/Atoms';
import api from '../../../../api/api';

function Stripe() {
  const business = useRecoilValue(businessAtom);
  const [page, setPage] = useRecoilState(pageAtom);
  const [rows, setRows] = useRecoilState(rowsAtom);
  const setStripePayouts = useSetRecoilState(stripePayoutsAtom);
  const setLoadingStripePayouts = useSetRecoilState(loadingStripePayoutsAtom);
  const [refreshStripePayouts, setRefreshStripePayouts] = useRecoilState(refreshStripePayoutsAtom);
  function getData() {
    setLoadingStripePayouts(true);
    setRefreshStripePayouts(false);
    let tempPage = page - 1;
    if (tempPage < 0) {
      tempPage = 0;
    }
    let url = `payments/payoutswithcountbytype/0/${tempPage}/${rows}`;
    if (business) {
      url += `/${business.id}`;
    }
    api
      .get(url)
      .then((response) => {
        setLoadingStripePayouts(false);
        if (response.data.success) {
          setStripePayouts(response.data.data);
        } else {
          setStripePayouts(null);
        }
      })
      .catch(() => {
        setLoadingStripePayouts(false);
      });
  }
  useEffect(async () => {
    await setPage(0);
    await setRows(10);
    getData();
  }, []);
  useEffect(() => {
    getData();
  }, [business, page, refreshStripePayouts, rows]);
  useEffect(() => {
    if (refreshStripePayouts) {
      getData();
    }
  }, [refreshStripePayouts]);
  return (
    <>
      <Header />
      {/* <Balances /> */}
      {/* <Divider /> */}
      <Activities />
    </>
  );
}

export default Stripe;
